import "can/model/";

export default can.Model.extend({
    findAll: function( headers ) {
        "use strict";

        headers = headers ? headers : {};

        return can.ajax({
            url: "/api/v2/accounts",
            type: "GET",
            dataType: "json",
            headers: headers
        });
    },

    findOne: function( params, headers ) {
        "use strict";

        headers = headers ? headers : {};

        return can.ajax({
            url: "/api/v2/accounts/" + params.id,
            type: "GET",
            dataType: "json",
            headers: headers
        });
    },

    findChildAccounts: function( params, headers ) {
        "use strict";

        const url = params
            ? `/api/v2/accounts/meta/tree?${can.param(params)}`
            : `/api/v2/accounts/meta/tree`;

        return can.ajax({
            url,
            type: "GET",
            dataType: "json",
            headers: headers || {},
        }).then( responseData => {
            return this.models( responseData );
        });
    },

    // Source: http://stackoverflow.com/questions/26290976/canjs-extending-can-model-with-additional-methods
    findCertainAccounts: function( params, headers ) {
        "use strict";

        headers = headers ? headers : {};

        return can.ajax({
            url: "/api/v2/accounts/" + params.accountIds,
            type: "GET",
            dataType: "json",
            headers: headers
        })
        .then( responseData => {
            return this.models( responseData );
        });
    },

    create: function( params ) {
        "use strict";

        var headers = params.headers ? params.headers : {};

        return can.ajax({
            url: "/api/v2/accounts",
            type: "POST",
            data: JSON.stringify( params.accounts ),
            headers: headers,
            contentType: "application/json"
        });
    },

    update: function( id, params ) {
        "use strict";

        return can.ajax({
            url: "/api/v2/accounts",
            type: "PUT",
            data: JSON.stringify( params.accounts ),
            contentType: "application/json",
            dataType: "JSON"
        });
    },

    getSubAccountsForAParentAccount: function( params, headers ) {
        "use strict";

        headers = headers ? headers : {};

        return can.ajax({
            url: `/api/v2/subAccounts/`+ params.accountId,
            type: "GET",
            dataType: "json",
            headers: headers
        });
    },

    destroy: "DELETE /api/v2/accounts/{id}"

}, {});
